import styled from 'styled-components';

export const Fields = styled.div`
  position: relative;

  .square {
    display: inline-block;
    width: 15px;
    height: 15px;
    background-color: black;
    margin: 0 10px 0 0;
  }

  .total-area {
    position: absolute;
    top: 2px;
    right: 10px;
  }

  .field-information-stat-wrap {
    margin: 0 0 20px;
    display: flex;

    label {
      width: 150px;
    }

    .field-information-stat {
      margin-top: 0;
    }
  }
`;

export const FieldPanelRight = styled.div`
  width: 100%;
  .field-panel-top-right {
    width: 100%;
    height: 100%;
    max-height: 60vh;
  }

  .field-panel-bottom-right {
    height: calc(40vh - 48px);
  }

  .field-panel-chart {
    height: 100%;
  }
`;
